import { Button, Label, Modal } from 'flowbite-react';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import Select, { SingleValue } from 'react-select';
import { Dropdown, isUserSuperAccountManager } from 'shared-utils';
import { getCompanyBySearch } from 'src/apis/company';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	isOpen: boolean;
	selectedCompany: string;
	setSelectedCompany: (c: string) => void;
	onClose: () => void;
	handleSubmit: (event: React.FormEvent) => void;
}

const ConfirmCompanyNameModal = ({ isOpen, selectedCompany, setSelectedCompany, handleSubmit }: Props) => {
	const [isMounted, setIsMounted] = useState(false);
	const { user } = useUserContext();
	const [companyNameOptions, setCompanyNameOptions] = useState<Dropdown[]>([]);

	const labelStyle = `dark:text-white text-[#111928]`;

	const changeHandler = (search: string) => {
		if (!search && user?.role && !isUserSuperAccountManager(user?.role)) {
			return;
		}
		getCompanyByIdFn.mutate({ search });
	};

	const debouncedChangeHandler = useCallback(debounce(changeHandler, 1000), []);

	const getCompanyByIdFn = useMutation(['getCompanyByIdForInviteRecruiter'], getCompanyBySearch, {
		onSuccess: data => {
			if (data && data?.company && data?.company?.length)
				setCompanyNameOptions(data?.company?.map(company => ({ label: company.name, value: company._id })) || []);
		},
		onError(error: Error) {
			console.log('error:', error);
		},
	});

	useEffect(() => {
		if (selectedCompany && !isMounted) {
			if (user?.role && isUserSuperAccountManager(user?.role)) {
				getCompanyByIdFn.mutate({ id: selectedCompany });
			} else {
				getCompanyByIdFn.mutate({ search: '' });
			}
			setIsMounted(true);
		}
	}, [selectedCompany, isMounted, user?.role]);

	return (
		<Modal show={isOpen} dismissible={false}>
			<Modal.Header>
				<div className="flex flex-col w-full h-full">
					<div>Please confirm the company name:</div>
					<p className="text-[#E57A00] text-[12px]">{`(Please note that once you confirm the action, it cannot be undone. Ensure that the spelling is correct before confirming.)`}</p>
				</div>
			</Modal.Header>
			<Modal.Body className="overflow-visible">
				<div className="flex font-inter flex-col gap-4">
					{/* Company Name */}
					<div>
						<div className="mb-2 block">
							<Label htmlFor="title" value="Company Name" className={`${labelStyle}`} />
							<span className="text-red-600 pl-1">*</span>
						</div>
						<Select
							options={companyNameOptions}
							menuPlacement={'auto'}
							classNamePrefix="my-select-plans"
							className="single-value-select-tag"
							onInputChange={data => {
								debouncedChangeHandler(data);
							}}
							value={companyNameOptions.find(comp => comp.value === selectedCompany)}
							onChange={(val: SingleValue<Dropdown>) => {
								if (val?.value) setSelectedCompany(val.value);
							}}
							placeholder="Search Company by Name"
						/>
					</div>

					{/* <div className="bg-white dark:bg-[#111E2C] bottom-0 mb-[-16px] md:mb-[-24px] mx-[-16px] md:mx-[-24px] shadow-up px-[16px] md:px-[24px] rounded-b-md"> */}
					<Button onClick={handleSubmit} color="purplePlaced" className="my-3 w-full" disabled={!selectedCompany}>
						Continue
					</Button>
					{/* </div> */}
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ConfirmCompanyNameModal;
